import _objectSpread from "C:\\vstsagent\\multiCribis-build-agent\\_work\\58\\s\\Source\\Crif.BlueBabylon.Web\\ClientApp\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _slicedToArray from "C:\\vstsagent\\multiCribis-build-agent\\_work\\58\\s\\Source\\Crif.BlueBabylon.Web\\ClientApp\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "C:\\vstsagent\\multiCribis-build-agent\\_work\\58\\s\\Source\\Crif.BlueBabylon.Web\\ClientApp\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "C:\\vstsagent\\multiCribis-build-agent\\_work\\58\\s\\Source\\Crif.BlueBabylon.Web\\ClientApp\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\vstsagent\\multiCribis-build-agent\\_work\\58\\s\\Source\\Crif.BlueBabylon.Web\\ClientApp\\node_modules\\@babel\\runtime/helpers/esm/createClass";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
import { LogLevel } from "./ILogger";
import { NullLogger } from "./Loggers";
// Version token that will be replaced by the prepack command
/** The version of the SignalR client. */
export var VERSION = "8.0.7";
/** @private */
export var Arg = /*#__PURE__*/function () {
  function Arg() {
    _classCallCheck(this, Arg);
  }
  _createClass(Arg, null, [{
    key: "isRequired",
    value: function isRequired(val, name) {
      if (val === null || val === undefined) {
        throw new Error("The '".concat(name, "' argument is required."));
      }
    }
  }, {
    key: "isNotEmpty",
    value: function isNotEmpty(val, name) {
      if (!val || val.match(/^\s*$/)) {
        throw new Error("The '".concat(name, "' argument should not be empty."));
      }
    }
  }, {
    key: "isIn",
    value: function isIn(val, values, name) {
      // TypeScript enums have keys for **both** the name and the value of each enum member on the type itself.
      if (!(val in values)) {
        throw new Error("Unknown ".concat(name, " value: ").concat(val, "."));
      }
    }
  }]);
  return Arg;
}();
/** @private */
export var Platform = /*#__PURE__*/function () {
  function Platform() {
    _classCallCheck(this, Platform);
  }
  _createClass(Platform, null, [{
    key: "isBrowser",
    // react-native has a window but no document so we should check both
    get: function get() {
      return !Platform.isNode && typeof window === "object" && typeof window.document === "object";
    } // WebWorkers don't have a window object so the isBrowser check would fail
  }, {
    key: "isWebWorker",
    get: function get() {
      return !Platform.isNode && typeof self === "object" && "importScripts" in self;
    } // react-native has a window but no document
  }, {
    key: "isReactNative",
    get: function get() {
      return !Platform.isNode && typeof window === "object" && typeof window.document === "undefined";
    } // Node apps shouldn't have a window object, but WebWorkers don't either
    // so we need to check for both WebWorker and window
  }, {
    key: "isNode",
    get: function get() {
      return typeof process !== "undefined" && process.release && process.release.name === "node";
    }
  }]);
  return Platform;
}();
/** @private */
export function getDataDetail(data, includeContent) {
  var detail = "";
  if (isArrayBuffer(data)) {
    detail = "Binary data of length ".concat(data.byteLength);
    if (includeContent) {
      detail += ". Content: '".concat(formatArrayBuffer(data), "'");
    }
  } else if (typeof data === "string") {
    detail = "String data of length ".concat(data.length);
    if (includeContent) {
      detail += ". Content: '".concat(data, "'");
    }
  }
  return detail;
}
/** @private */
export function formatArrayBuffer(data) {
  var view = new Uint8Array(data);
  // Uint8Array.map only supports returning another Uint8Array?
  var str = "";
  view.forEach(function (num) {
    var pad = num < 16 ? "0" : "";
    str += "0x".concat(pad).concat(num.toString(16), " ");
  });
  // Trim of trailing space.
  return str.substr(0, str.length - 1);
}
// Also in signalr-protocol-msgpack/Utils.ts
/** @private */
export function isArrayBuffer(val) {
  return val && typeof ArrayBuffer !== "undefined" && (val instanceof ArrayBuffer ||
  // Sometimes we get an ArrayBuffer that doesn't satisfy instanceof
  val.constructor && val.constructor.name === "ArrayBuffer");
}
/** @private */
export function sendMessage(_x, _x2, _x3, _x4, _x5, _x6) {
  return _sendMessage.apply(this, arguments);
}
/** @private */
function _sendMessage() {
  _sendMessage = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(logger, transportName, httpClient, url, content, options) {
    var headers, _getUserAgentHeader, _getUserAgentHeader2, name, value, responseType, response;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          headers = {};
          _getUserAgentHeader = getUserAgentHeader(), _getUserAgentHeader2 = _slicedToArray(_getUserAgentHeader, 2), name = _getUserAgentHeader2[0], value = _getUserAgentHeader2[1];
          headers[name] = value;
          logger.log(LogLevel.Trace, "(".concat(transportName, " transport) sending data. ").concat(getDataDetail(content, options.logMessageContent), "."));
          responseType = isArrayBuffer(content) ? "arraybuffer" : "text";
          _context.next = 7;
          return httpClient.post(url, {
            content: content,
            headers: _objectSpread({}, headers, options.headers),
            responseType: responseType,
            timeout: options.timeout,
            withCredentials: options.withCredentials
          });
        case 7:
          response = _context.sent;
          logger.log(LogLevel.Trace, "(".concat(transportName, " transport) request complete. Response status: ").concat(response.statusCode, "."));
        case 9:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _sendMessage.apply(this, arguments);
}
export function createLogger(logger) {
  if (logger === undefined) {
    return new ConsoleLogger(LogLevel.Information);
  }
  if (logger === null) {
    return NullLogger.instance;
  }
  if (logger.log !== undefined) {
    return logger;
  }
  return new ConsoleLogger(logger);
}
/** @private */
export var SubjectSubscription = /*#__PURE__*/function () {
  function SubjectSubscription(subject, observer) {
    _classCallCheck(this, SubjectSubscription);
    this._subject = subject;
    this._observer = observer;
  }
  _createClass(SubjectSubscription, [{
    key: "dispose",
    value: function dispose() {
      var index = this._subject.observers.indexOf(this._observer);
      if (index > -1) {
        this._subject.observers.splice(index, 1);
      }
      if (this._subject.observers.length === 0 && this._subject.cancelCallback) {
        this._subject.cancelCallback().catch(function (_) {});
      }
    }
  }]);
  return SubjectSubscription;
}();
/** @private */
export var ConsoleLogger = /*#__PURE__*/function () {
  function ConsoleLogger(minimumLogLevel) {
    _classCallCheck(this, ConsoleLogger);
    this._minLevel = minimumLogLevel;
    this.out = console;
  }
  _createClass(ConsoleLogger, [{
    key: "log",
    value: function log(logLevel, message) {
      if (logLevel >= this._minLevel) {
        var msg = "[".concat(new Date().toISOString(), "] ").concat(LogLevel[logLevel], ": ").concat(message);
        switch (logLevel) {
          case LogLevel.Critical:
          case LogLevel.Error:
            this.out.error(msg);
            break;
          case LogLevel.Warning:
            this.out.warn(msg);
            break;
          case LogLevel.Information:
            this.out.info(msg);
            break;
          default:
            // console.debug only goes to attached debuggers in Node, so we use console.log for Trace and Debug
            this.out.log(msg);
            break;
        }
      }
    }
  }]);
  return ConsoleLogger;
}();
/** @private */
export function getUserAgentHeader() {
  var userAgentHeaderName = "X-SignalR-User-Agent";
  if (Platform.isNode) {
    userAgentHeaderName = "User-Agent";
  }
  return [userAgentHeaderName, constructUserAgent(VERSION, getOsName(), getRuntime(), getRuntimeVersion())];
}
/** @private */
export function constructUserAgent(version, os, runtime, runtimeVersion) {
  // Microsoft SignalR/[Version] ([Detailed Version]; [Operating System]; [Runtime]; [Runtime Version])
  var userAgent = "Microsoft SignalR/";
  var majorAndMinor = version.split(".");
  userAgent += "".concat(majorAndMinor[0], ".").concat(majorAndMinor[1]);
  userAgent += " (".concat(version, "; ");
  if (os && os !== "") {
    userAgent += "".concat(os, "; ");
  } else {
    userAgent += "Unknown OS; ";
  }
  userAgent += "".concat(runtime);
  if (runtimeVersion) {
    userAgent += "; ".concat(runtimeVersion);
  } else {
    userAgent += "; Unknown Runtime Version";
  }
  userAgent += ")";
  return userAgent;
}
// eslint-disable-next-line spaced-comment
/*#__PURE__*/
function getOsName() {
  if (Platform.isNode) {
    switch (process.platform) {
      case "win32":
        return "Windows NT";
      case "darwin":
        return "macOS";
      case "linux":
        return "Linux";
      default:
        return process.platform;
    }
  } else {
    return "";
  }
}
// eslint-disable-next-line spaced-comment
/*#__PURE__*/
function getRuntimeVersion() {
  if (Platform.isNode) {
    return process.versions.node;
  }
  return undefined;
}
function getRuntime() {
  if (Platform.isNode) {
    return "NodeJS";
  } else {
    return "Browser";
  }
}
/** @private */
export function getErrorString(e) {
  if (e.stack) {
    return e.stack;
  } else if (e.message) {
    return e.message;
  }
  return "".concat(e);
}
/** @private */
export function getGlobalThis() {
  // globalThis is semi-new and not available in Node until v12
  if (typeof globalThis !== "undefined") {
    return globalThis;
  }
  if (typeof self !== "undefined") {
    return self;
  }
  if (typeof window !== "undefined") {
    return window;
  }
  if (typeof global !== "undefined") {
    return global;
  }
  throw new Error("could not find global");
}